import { envSchema } from './env-schema';

/**
 * 클라이언트 환경변수.
 *
 * Vite 는 `VITE_` 접두사가 붙은 값만 번들에 노출한다.
 * 부팅 시점에 검증해 잘못된 설정이 런타임 오류로 늦게 드러나는 것을 막는다.
 */
const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const details = parsed.error.issues
    .map((issue) => `  - ${issue.path.join('.')}: ${issue.message}`)
    .join('\n');
  throw new Error(`환경변수 검증에 실패했습니다:\n${details}`);
}

export const env = parsed.data;

/** Vite 개발 서버 여부 — 개발 모드 측정 로그(미리보기 렌더 시간 등)에만 쓴다. */
export const isDev: boolean = import.meta.env.DEV;
